import { UserEntity } from "../entity/UserEntity";
import { User } from "../gateway/User/User";

export class GetUsersAccountingIdRolesUsecase {
    constructor() {
        this.UserGateway = new User();
    }

    async execute({ accountingId = "", roles = [], options = {} } = {}) {
        const payload = this.sanitizeInput({ accountingId, roles, options });
        if (!payload.accountingId || !payload.roles.length) return [];
        const response = await this.UserGateway.getUsersByRolesAndAccountingId({
            accountingId: payload.accountingId,
            roles: payload.roles,
            options: payload.options
        });
        const list = response?.list;
        if (!Array.isArray(list) || !list.length) return [];
        return list.map((user) => UserEntity.restoreFromCloud(user));
    }

    sanitizeInput({ accountingId = "", roles = [], options = {} } = {}) {
        const sanitizedAccountingId = String(accountingId).trim();
        const sanitizedRoles =
            Array.isArray(roles) && roles.length
                ? roles.filter((role) => Boolean(String(role).trim()))
                : [];
        const sanitizedOptions =
            options && typeof options === "object" && !Array.isArray(options)
                ? options
                : {};
        return {
            accountingId: sanitizedAccountingId,
            roles: sanitizedRoles,
            options: sanitizedOptions
        };
    }
}
